import { FC, useContext } from 'react';
import { Heading } from '@alto-avios/alto-ui';

import { useUserDetailsError } from '../../contexts/userDetailsError';
import { pushGTMEvent } from '../../utilities';
import { Button } from '../Button';
import { ErrorCard } from '../ErrorCard';
import { AuthProps } from '../Header';
import { CMSProviderContext } from '../services/content';

import styles from './ManageAvios.module.scss';

export interface ManageAviosProps {
  firstName: string;
  aviosBalance?: number;
  logoutProps: AuthProps['logoutProps'];
}

export const ManageAvios: FC<ManageAviosProps> = ({ aviosBalance, firstName, logoutProps }) => {
  const { header } = useContext(CMSProviderContext);
  const { userBalanceError, userDetailsError } = useUserDetailsError();
  const { account } = header.data;
  const { href, onClick } = logoutProps;
  const welcomeMessage = account.header.replace('{{user.name}}', firstName);
  const isValidBalance = typeof aviosBalance === 'number' && aviosBalance >= 0;

  return (
    <div className={styles.popoverContent}>
      <div className={styles.userInfo}>
        {!userDetailsError && (
          <>
            <Heading as="h2" foregroundColor="secondary" size="xxs">
              {welcomeMessage}
            </Heading>
            <div className={styles.aviosBalance}>
              <span className={styles.aviosNumber}>{isValidBalance && !userBalanceError ? aviosBalance.toLocaleString('en-GB') : '-'}</span>
              <span className={styles.aviosLabel}>{account.balanceLabel}</span>
            </div>
            {(userBalanceError || !isValidBalance) && <ErrorCard errorMessage={account.userDataErrorMessage} />}
          </>
        )}
      </div>

      <div className={styles.buttonContainer}>
        {account.links.map(({ label, leftIcon, url }) => (
          <Button
            key={label}
            iconStartProps={leftIcon ? { iconName: leftIcon } : undefined}
            href={url}
            emphasis="quaternary"
            styleVariant="neutral"
            onPress={() => pushGTMEvent('manage avios', label)}
            fullWidth
          >
            {label}
          </Button>
        ))}
      </div>
      <div className={styles.signOutContainer}>
        <Button
          href={href}
          iconStartProps={{ iconName: account.logout.icon }}
          emphasis="quaternary"
          styleVariant="accent"
          onPress={onClick}
          disableRouting
          fullWidth
        >
          {account.logout.label}
        </Button>
      </div>
    </div>
  );
};
